import {default as axios} from "./axiosConfig";
import config, {axiosConfig} from "../config";

import {FieldMetaRequest, FieldRequest, FieldValidateRequest, UpdateFieldRequest} from "./model/validation";
import {IReactField, ISelectItem} from "./model/reactField";
import * as log from "../utils/log";
import {getFuncMod} from "../utils/log";
import {ProductType} from "./model/common";

const getBackType = (type: ProductType) => type === ProductType.TRAVEL ? "TRAVEL" : "MTPL"

export async function getFieldValidationMeta(fields: FieldRequest[], quotation: any, type: ProductType) {
    const date = new Date();
    let data;
    const fieldMetaRequest: FieldMetaRequest = {
        quotation: quotation.quotation ? quotation.quotation: quotation,
        type: getBackType(type),
        fields: fields
    };
    await axios.post(`${config.API_URL}/validation/meta`, fieldMetaRequest, axiosConfig)
        .then(response => {
            data = response.data
            log.sendLog(date, getFuncMod(type), 'INFO',"GET_FIELD_VALIDATION_META", [{quotation: quotation, fields: fields, responseData: data}], '');
        })
        .catch((err) => {
            log.sendLog(date, getFuncMod(type), 'INFO',"GET_FIELD_VALIDATION_META_FAILED_NO_RESPONSE", [{quotation: quotation, fields: fields}], err.response);
        })

    return data
}

export async function validateField(quotation: object, fields: FieldRequest[], type: ProductType) {
    const date = new Date();
    let data;
    const request: FieldValidateRequest = {
        quotation,
        fields,
        type: getBackType(type)
    };
    await axios.post(`${config.API_URL}/validation/validate`, request, axiosConfig)
        .then(response => {
            data = response.data
            log.sendLog(date, getFuncMod(type), 'INFO',"FIELD_VALIDATION", [{quotation: quotation, fields: fields, responseData: data}], '');
        })
        .catch((err) => {
            log.sendLog(date, getFuncMod(type), 'INFO',"FIELD_VALIDATION_FAILED_NO_RESPONSE", [{quotation: quotation, fields: fields}], err.response);
            throw new Error(err);
        })

    return data
}

let updateFieldController: AbortController;
let updateFieldName: string;
export const updateFieldByRequest = async (quotation: any, contextPath: string, fieldName: string, value: any, type: ProductType): Promise<Map<string, IReactField>> => {
    const date = new Date();
    let data;
    const request: UpdateFieldRequest = {
        "quotation": quotation.quotation ? quotation.quotation: quotation,
        "contextPath": contextPath,
        "fieldName": fieldName,
        "value":  value,
        "type": getBackType(type)
    };
    if (updateFieldController && fieldName === updateFieldName) updateFieldController.abort();
    updateFieldName = fieldName;
    updateFieldController = new AbortController();

    await axios.post(`${config.API_URL}/validation/update-field`, request, {...axiosConfig, signal: updateFieldController.signal})
        .then(response => {
            data = response.data
            log.sendLog(date, getFuncMod(type), 'INFO',"UPDATE_FIELD", [{contextPath: contextPath, fieldName: fieldName, value: value, responseData: data}], '');
        })
        .catch((err) => {
            log.sendLog(date, getFuncMod(type), 'INFO',"UPDATE_FIELD_FAILED_NO_RESPONSE", [{contextPath: contextPath, fieldName: fieldName, value: value}], err.response);
        })


    return data;
}

export const getFunctionSelectItemsByDealIdAndFieldNameAndFormName = async (quotation: object, contextPath: string, fieldName: string, type: ProductType, query?: string): Promise<Array<ISelectItem>> => {
    const link = `${config.API_URL}/validation/items`;

    const response = await axios.post<Array<ISelectItem>>(link,
        {
            fieldName: fieldName,
            query: query,
            quotation: quotation,
            contextPath: contextPath,
            type: getBackType(type)
        }
    );

    return response.data;
}

